import { defaultSettings } from '../pages/admin/settings/settingsData';

let cached = {
  gym: { ...defaultSettings.gym },
  currency: { ...defaultSettings.currency },
  logoPreview: null,
  invoiceSequenceStart: defaultSettings.invoiceSequenceStart,
};

export function getGymSettings() {
  return cached;
}

export function setGymSettingsCache(settings) {
  if (!settings) return cached;
  const invoiceSequenceStart = Number(settings.invoiceSequenceStart);
  cached = {
    gym: { ...defaultSettings.gym, ...(settings.gym || {}) },
    currency: {
      code: settings.currency?.code || defaultSettings.currency.code,
      symbol: settings.currency?.symbol || defaultSettings.currency.symbol,
      position: settings.currency?.position || defaultSettings.currency.position,
      decimalPlaces: Number(
        settings.currency?.decimalPlaces ?? defaultSettings.currency.decimalPlaces,
      ),
    },
    logoPreview: settings.logoPreview ?? null,
    invoiceSequenceStart: Number.isFinite(invoiceSequenceStart) && invoiceSequenceStart > 0
      ? Math.floor(invoiceSequenceStart)
      : defaultSettings.invoiceSequenceStart,
  };
  return cached;
}

export function formatGymPrice(amount, settings = cached) {
  const currency = settings?.currency || defaultSettings.currency;
  const decimals = Number(currency.decimalPlaces ?? 0);
  const formatted = Number(amount || 0).toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  const symbol = currency.symbol || 'Rs';
  return currency.position === 'after'
    ? `${formatted} ${symbol}`
    : `${symbol} ${formatted}`;
}

export function formatGymCompact(amount, settings = cached) {
  const currency = settings?.currency || defaultSettings.currency;
  const symbol = currency.symbol || 'Rs';
  const n = Number(amount || 0);
  const compact = Math.abs(n) >= 1000 ? `${(n / 1000).toFixed(0)}k` : String(Math.round(n));
  const signed = n < 0 ? `-${compact.replace('-', '')}` : compact;
  return currency.position === 'after' ? `${signed} ${symbol}` : `${symbol} ${signed}`;
}
